module.exports = __webpack_public_path__ + "img/footer-image.ed99f969.jpg";